import { TriangleAlert } from 'lucide-react';

import { useDemoMode } from '../lib/demo-mode';

/**
 * Плашка демо-режима.
 *
 * Показывается, когда хотя бы одна внешняя система работает заглушкой. Без неё на
 * показе заказчику подписанный ЭПЛ выглядит настоящим: подпись имитирована, а в ЕСУТД
 * ничего не уходило. Состояние берётся с бэкенда, а не из сборки фронта, чтобы плашка
 * не могла разойтись с фактическим режимом сервиса.
 */
export function DemoBanner() {
  const data = useDemoMode();

  if (!data?.demoMode) {
    return null;
  }

  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-x-2 gap-y-1 bg-amber-100 px-3 py-2 text-xs text-amber-900 sm:px-4"
    >
      <TriangleAlert className="h-4 w-4 shrink-0" aria-hidden />
      <span className="font-semibold uppercase tracking-wide">Демо-режим</span>
      <span>
        {data.signatureMocked
          ? 'подпись имитируется, путевые листы юридически недействительны;'
          : 'часть внешних систем отключена;'}{' '}
        обмен не выполняется
      </span>
      {data.mocked.length > 0 ? (
        <span className="text-amber-800/80">заглушки: {data.mocked.join(', ')}</span>
      ) : null}
    </div>
  );
}
